/* eslint-disable promise/param-names */
import Vue from 'vue';
import {
  ADMIN_ADD_CATEGORY_ERROR,
  ADMIN_ADD_CATEGORY_REQUEST,
  ADMIN_ADD_CATEGORY_SUCCESS,
  ADMIN_ADD_DOCUMENT_ERROR,
  ADMIN_ADD_DOCUMENT_REQUEST,
  ADMIN_ADD_DOCUMENT_SUCCESS, ADMIN_DELETE_CATEGORY_ERROR,
  ADMIN_DELETE_CATEGORY_REQUEST,
  ADMIN_DELETE_CATEGORY_SUCCESS,
  ADMIN_DELETE_DOCUMENT_ERROR,
  ADMIN_DELETE_DOCUMENT_REQUEST,
  ADMIN_DELETE_DOCUMENT_SUCCESS,
  ADMIN_EDIT_CATEGORY_ERROR,
  ADMIN_EDIT_CATEGORY_REQUEST,
  ADMIN_EDIT_CATEGORY_SUCCESS,
  ADMIN_EDIT_DOCUMENT_ERROR,
  ADMIN_EDIT_DOCUMENT_REQUEST,
  ADMIN_EDIT_DOCUMENT_SUCCESS,
  ADMIN_GET_CATEGORIES_ERROR,
  ADMIN_GET_CATEGORIES_REQUEST,
  ADMIN_GET_CATEGORIES_SUCCESS,
  ADMIN_GET_CATEGORY_ERROR,
  ADMIN_GET_CATEGORY_REQUEST,
  ADMIN_GET_CATEGORY_SUCCESS,
  ADMIN_GET_DOCUMENT_ERROR,
  ADMIN_GET_DOCUMENT_REQUEST,
  ADMIN_GET_DOCUMENT_SUCCESS,
  ADMIN_GET_DOCUMENTS_ERROR,
  ADMIN_GET_DOCUMENTS_REQUEST,
  ADMIN_GET_DOCUMENTS_SUCCESS
} from './actiontypes';
import adminApi from '../../../_services/api/administration';

const state = {
  categories: [],
  documents: [],
  document: [],
  category: [],
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  getCategories: state => state.categories,
  getDocuments: state => state.documents,
};

const actions = {
  [ADMIN_GET_CATEGORIES_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_CATEGORIES_REQUEST);
      adminApi.getCategories()
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_CATEGORIES_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_CATEGORIES_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_CATEGORIES_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_DOCUMENTS_REQUEST]: ({ commit, dispatch }, target=null) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_DOCUMENTS_REQUEST);
      adminApi.getDocuments(target)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_DOCUMENTS_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_DOCUMENTS_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_DOCUMENTS_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_DOCUMENT_REQUEST]: ({ commit, dispatch }, document_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_DOCUMENT_REQUEST);
      adminApi.getDocument(document_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_DOCUMENT_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_DOCUMENT_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_DOCUMENT_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_ADD_DOCUMENT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_ADD_DOCUMENT_REQUEST);
      adminApi.addDocument(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_ADD_DOCUMENT_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_ADD_DOCUMENT_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_ADD_DOCUMENT_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_EDIT_DOCUMENT_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_ADD_DOCUMENT_REQUEST);
      console.log("in store document id is ==");
      console.log(payload);
      adminApi.editDocument(payload.id, payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_EDIT_DOCUMENT_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_EDIT_DOCUMENT_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_EDIT_DOCUMENT_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_DELETE_DOCUMENT_REQUEST]: ({ commit, dispatch }, document_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_DELETE_DOCUMENT_REQUEST);
      adminApi.deleteDocument(document_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_DELETE_DOCUMENT_SUCCESS, response.data);
            dispatch(ADMIN_GET_DOCUMENTS_REQUEST);
            resolve(response);
          } else {
            commit(ADMIN_DELETE_DOCUMENT_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_DELETE_DOCUMENT_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_GET_CATEGORY_REQUEST]: ({ commit, dispatch }, category_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_GET_CATEGORY_REQUEST);
      adminApi.getCategory(category_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_GET_CATEGORY_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_GET_CATEGORY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_GET_CATEGORY_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_ADD_CATEGORY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_ADD_CATEGORY_REQUEST);
      adminApi.addCategory(payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_ADD_CATEGORY_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_ADD_CATEGORY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_ADD_CATEGORY_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_EDIT_CATEGORY_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_EDIT_CATEGORY_REQUEST);
      adminApi.editCategory(payload.id, payload)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_EDIT_CATEGORY_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(ADMIN_EDIT_CATEGORY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_EDIT_CATEGORY_ERROR, error);
          reject(error);
        });
    });
  },
  [ADMIN_DELETE_CATEGORY_REQUEST]: ({ commit, dispatch }, category_id) => {
    return new Promise((resolve, reject) => {
      commit(ADMIN_DELETE_CATEGORY_REQUEST);
      adminApi.deleteCategory(category_id)
        .then((response) => {
          if (response.success === true) {
            commit(ADMIN_DELETE_CATEGORY_SUCCESS, response.data);
            dispatch(ADMIN_GET_CATEGORIES_REQUEST);
            resolve(response);
          } else {
            commit(ADMIN_DELETE_CATEGORY_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(ADMIN_DELETE_CATEGORY_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [ADMIN_GET_CATEGORIES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_CATEGORIES_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'categories', response.categories);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_CATEGORIES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_DOCUMENTS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_DOCUMENTS_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'documents', response.documents);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_DOCUMENTS_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_ADD_DOCUMENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_ADD_DOCUMENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_ADD_DOCUMENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_EDIT_DOCUMENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_EDIT_DOCUMENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_EDIT_DOCUMENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_DELETE_DOCUMENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_DELETE_DOCUMENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_DELETE_DOCUMENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_DOCUMENT_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_DOCUMENT_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'document', response.document);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_DOCUMENT_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [ADMIN_ADD_CATEGORY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_ADD_CATEGORY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_ADD_CATEGORY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_EDIT_CATEGORY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_EDIT_CATEGORY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_EDIT_CATEGORY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_DELETE_CATEGORY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_DELETE_CATEGORY_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [ADMIN_DELETE_CATEGORY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
  [ADMIN_GET_CATEGORY_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADMIN_GET_CATEGORY_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'category', response.category);
    state.hasLoadedOnce = true;
  },
  [ADMIN_GET_CATEGORY_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
